import { frontendURL } from '../../../../helper/URLHelper';
import {
  CUSTOM_REPORT_VIEW_PERMISSIONS,
  SURVEY_RESPONSE_VIEW_PERMISSIONS,
  SURVEY_MANAGE_PERMISSIONS,
} from '../../../../constants/permissions';

const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');
const AgentReports = () => import('./AgentReports.vue');
const LabelReports = () => import('./LabelReports.vue');
const InboxReports = () => import('./InboxReports.vue');
const TeamReports = () => import('./TeamReports.vue');
const SurveyCsatReport = () => import('./surveys/SurveyCsatReport.vue');
const SurveyNpsReport = () => import('./surveys/SurveyNpsReport.vue');
const BotReports = () => import('./BotReports.vue');
const AIReports = () => import('./AIReports.vue');
const LiveReports = () => import('./LiveReports.vue');
const SLAReports = () => import('./SLAReports.vue');
const CustomReportsIndex = () => import('./customReports/Index.vue');
const CustomReportPage = () => import('./customReports/CustomReportPage.vue');
const PanelEditor = () => import('./customReports/PanelEditor.vue');
const GoalsIndex = () => import('./goals/Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'OVERVIEW_REPORTS.HEADER',
        icon: 'arrow-trending-lines',
        keepAlive: false,
      },
      children: [
        {
          path: '',
          redirect: 'overview',
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: LiveReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'REPORT.HEADER',
        icon: 'chat',
        keepAlive: false,
      },
      children: [
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: Index,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'SURVEY_REPORTS.CSAT.HEADER',
        icon: 'emoji',
        keepAlive: false,
      },
      children: [
        {
          // Nome mantido: links e favoritos que apontam para `csat_reports` continuam
          // funcionando depois da troca do relatório legado.
          path: 'csat',
          name: 'csat_reports',
          meta: {
            permissions: [
              'administrator',
              SURVEY_RESPONSE_VIEW_PERMISSIONS,
              SURVEY_MANAGE_PERMISSIONS,
            ],
          },
          component: SurveyCsatReport,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'SURVEY_REPORTS.NPS.HEADER',
        icon: 'poll-outline',
        keepAlive: false,
      },
      children: [
        {
          path: 'nps',
          name: 'nps_reports',
          meta: {
            permissions: [
              'administrator',
              SURVEY_RESPONSE_VIEW_PERMISSIONS,
              SURVEY_MANAGE_PERMISSIONS,
            ],
          },
          component: SurveyNpsReport,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'BOT_REPORTS.HEADER',
        icon: 'bot',
        keepAlive: false,
      },
      children: [
        {
          path: 'bot',
          name: 'bot_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: BotReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'AI_REPORTS.HEADER',
        icon: 'bot',
        keepAlive: false,
      },
      children: [
        {
          path: 'ai',
          name: 'ai_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: AIReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'AGENT_REPORTS.HEADER',
        icon: 'people',
        keepAlive: false,
      },
      children: [
        {
          path: 'agent',
          name: 'agent_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: AgentReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'LABEL_REPORTS.HEADER',
        icon: 'tag',
        keepAlive: false,
      },
      children: [
        {
          path: 'label',
          name: 'label_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: LabelReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'INBOX_REPORTS.HEADER',
        icon: 'mail-inbox-all',
        keepAlive: false,
      },
      children: [
        {
          path: 'inboxes',
          name: 'inbox_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: InboxReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'TEAM_REPORTS.HEADER',
        icon: 'people-team',
      },
      children: [
        {
          path: 'teams',
          name: 'team_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: TeamReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'SLA_REPORTS.HEADER',
        icon: 'document-list-clock',
        keepAlive: false,
      },
      children: [
        {
          path: 'sla',
          name: 'sla_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: SLAReports,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'CUSTOM_REPORTS.HEADER',
        icon: 'bar-chart-outline',
        keepAlive: false,
        headerBadge: 'BETA',
      },
      children: [
        {
          path: 'custom',
          name: 'custom_reports',
          meta: {
            permissions: ['administrator', CUSTOM_REPORT_VIEW_PERMISSIONS],
          },
          component: CustomReportsIndex,
        },
        {
          path: 'custom/new',
          name: 'custom_reports_new',
          meta: {
            permissions: ['administrator', CUSTOM_REPORT_VIEW_PERMISSIONS],
          },
          component: CustomReportPage,
        },
        {
          path: 'custom/:reportId',
          name: 'custom_reports_show',
          meta: {
            permissions: ['administrator', CUSTOM_REPORT_VIEW_PERMISSIONS],
          },
          component: CustomReportPage,
          props: true,
        },
        {
          path: 'custom/:reportId/panels/new',
          name: 'custom_reports_panel_new',
          meta: {
            permissions: ['administrator', CUSTOM_REPORT_VIEW_PERMISSIONS],
          },
          component: PanelEditor,
          props: route => ({ reportId: route.params.reportId, panelId: null }),
        },
        {
          path: 'custom/:reportId/panels/:panelId/edit',
          name: 'custom_reports_panel_edit',
          meta: {
            permissions: ['administrator', CUSTOM_REPORT_VIEW_PERMISSIONS],
          },
          component: PanelEditor,
          props: route => ({
            reportId: route.params.reportId,
            panelId: route.params.panelId,
          }),
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'GOALS.HEADER',
        icon: 'checkmark-circle-outline',
        keepAlive: false,
      },
      children: [
        {
          path: 'goals',
          name: 'goals_index',
          meta: {
            permissions: ['administrator', CUSTOM_REPORT_VIEW_PERMISSIONS],
          },
          component: GoalsIndex,
        },
      ],
    },
  ],
};
